import * as React from 'react'

const RedCircleCrossIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={12} cy={12} r={11} stroke="#FE655E" strokeWidth={2} />
    <path
      d="M8 8.00128L15.9971 15.9984"
      stroke="#FE655E"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M16 8.00128L8.00293 15.9984"
      stroke="#FE655E"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
)
export default RedCircleCrossIcon
